<template>
  <div ref="root" class="multiEventoButtonWrapper">
    <button
      type="button"
      class="multiEventoButton"
      title="Abrir multi-eventos"
      aria-label="Abrir multi-eventos"
      :aria-expanded="menuAberto ? 'true' : 'false'"
      @click="alternarMenu"
    >
      <i class="fa fa-th-large" aria-hidden="true"></i>
      <span>Multi-eventos</span>
      <i class="fa fa-angle-down" aria-hidden="true"></i>
    </button>

    <div v-if="menuAberto" class="multiEventoWorkspacesMenu">
      <button type="button" class="novo" @click="abrirNovo">
        <i class="fa fa-plus" aria-hidden="true"></i>
        <span>Novo workspace</span>
      </button>

      <div v-if="recentes.length" class="multiEventoWorkspacesRecentes">
        <small>Workspaces recentes</small>
        <button
          v-for="workspace in recentes"
          :key="workspace.id"
          type="button"
          :title="workspace.nome"
          @click="abrir(workspace.id)"
        >
          <i class="fa fa-window-restore" aria-hidden="true"></i>
          <span>
            <strong>{{ workspace.nome }}</strong>
            <small>{{ formatarData(workspace.atualizadoEm) }}</small>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  gerarMultiWorkspaceId,
  listarMultiWorkspaces,
} from "@/services/multiEvento.js";

export default {
  name: "MultiEventoButton",
  data() {
    return {
      menuAberto: false,
      recentes: [],
    };
  },
  mounted() {
    document.addEventListener("mousedown", this.cliqueExterno);
  },
  beforeDestroy() {
    document.removeEventListener("mousedown", this.cliqueExterno);
  },
  methods: {
    alternarMenu() {
      this.recentes = listarMultiWorkspaces(this.usuarioKey());
      this.menuAberto = !this.menuAberto;
    },
    abrirNovo() {
      this.abrir(gerarMultiWorkspaceId());
    },
    abrir(workspaceId) {
      window.open(
        "/multi?workspace=" + encodeURIComponent(workspaceId),
        "multi_eventos_" + workspaceId,
        "scrollbars=0,resizable=1,width=1100,height=760"
      );
      this.menuAberto = false;
    },
    formatarData(valor) {
      if (!valor) {
        return "";
      }
      return new Intl.DateTimeFormat("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      }).format(new Date(valor));
    },
    cliqueExterno(evento) {
      if (
        this.menuAberto &&
        this.$refs.root &&
        !this.$refs.root.contains(evento.target)
      ) {
        this.menuAberto = false;
      }
    },
    usuarioKey() {
      return this.$sessao && this.$sessao.usuario
        ? this.$sessao.usuario._id || this.$sessao.usuario.email || ""
        : "";
    },
  },
};
</script>

<style>
.multiEventoButtonWrapper {
  position: relative;
  z-index: 40;
}

.multiEventoButton {
  align-items: center;
  background: #ffffff;
  border: 1px solid #aab5bc;
  border-radius: 3px;
  color: #34434c;
  cursor: pointer;
  display: inline-flex;
  font-size: 10px;
  font-weight: 600;
  gap: 7px;
  height: 34px;
  justify-content: center;
  padding: 0 10px;
}

.multiEventoButton > i:last-child {
  color: #7b878e;
  font-size: 8px;
}

.multiEventoWorkspacesMenu {
  background: #ffffff;
  border: 1px solid #aab5bc;
  box-shadow: 0 8px 22px rgba(27, 37, 43, 0.2);
  min-width: 290px;
  padding: 6px;
  position: absolute;
  right: 0;
  top: 39px;
  z-index: 100;
}

.multiEventoWorkspacesMenu > button,
.multiEventoWorkspacesRecentes > button {
  align-items: center;
  background: transparent;
  border: 0;
  color: #34434c;
  display: grid;
  gap: 9px;
  grid-template-columns: 18px minmax(0, 1fr);
  min-height: 42px;
  padding: 7px 9px;
  text-align: left;
  width: 100%;
}

.multiEventoWorkspacesMenu > button:hover,
.multiEventoWorkspacesRecentes > button:hover {
  background: #edf2f4;
}

.multiEventoWorkspacesMenu > button.novo {
  border-bottom: 1px solid #dce2e5;
  color: #147b55;
  font-weight: 700;
}

.multiEventoWorkspacesRecentes > small {
  color: #718089;
  display: block;
  font-size: 8px;
  font-weight: 700;
  padding: 9px 9px 4px;
  text-transform: uppercase;
}

.multiEventoWorkspacesRecentes > button > span,
.multiEventoWorkspacesRecentes strong,
.multiEventoWorkspacesRecentes small {
  display: block;
  min-width: 0;
}

.multiEventoWorkspacesRecentes strong {
  font-size: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.multiEventoWorkspacesRecentes small {
  color: #75828a;
  font-size: 8px;
  margin-top: 2px;
}

.multiEventoButton:hover {
  background: #f2f5f6;
  border-color: #73818a;
}

.body-dark .multiEventoButton {
  background: #1d252a;
  border-color: #46535b;
  color: #dfe5e8;
}

.body-dark .multiEventoButton:hover {
  background: #283239;
}

.body-dark .multiEventoWorkspacesMenu {
  background: #1d252a;
  border-color: #46535b;
}

.body-dark .multiEventoWorkspacesMenu > button,
.body-dark .multiEventoWorkspacesRecentes > button {
  color: #dfe5e8;
}

.body-dark .multiEventoWorkspacesMenu > button:hover,
.body-dark .multiEventoWorkspacesRecentes > button:hover {
  background: #2a353b;
}

.body-dark .multiEventoWorkspacesMenu > button.novo {
  border-color: #3f4b52;
  color: #4fc695;
}

@media (max-width: 575px) {
  .multiEventoWorkspacesMenu {
    max-width: calc(100vw - 28px);
    min-width: 270px;
  }
}
</style>
